import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import { HomeOutlined, FormOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

const CashDisbursementStaffNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [menuItems, setMenuItems] = useState([]);

	useEffect(() => {
		setMenuItems([
			{
				key: "/utils/cash-disbursement/create",
				icon: <FormOutlined />,
				label: "지출결의서 작성",
			},
			{
				key: "/utils/cash-disbursement/my-list",
				icon: <UnorderedListOutlined />,
				label: "작성 내역",
			},
		]);
	}, []);

	const handleMenuClick = ({ key }) => {
		navigate(key);
	};

	const getSelectedKey = () => {
		const path =
			(location.pathname || "/").replace(/\/+$/, "") || "/";
		const exact = menuItems.find((item) => item.key === path);
		if (exact) return exact.key;
		if (path.startsWith("/utils/cash-disbursement/my-list")) {
			return "/utils/cash-disbursement/my-list";
		}
		if (path.startsWith("/utils/cash-disbursement/edit")) {
			return "/utils/cash-disbursement/create";
		}
		return "/utils/cash-disbursement/create";
	};

	return (
		<Sider
			width={250}
			className="member-navigation__sider"
			breakpoint="lg"
			collapsedWidth="0">
			<div className="member-navigation__logo">
				<HomeOutlined />
				<span>지출결의서</span>
			</div>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[getSelectedKey()]}
				items={menuItems}
				onClick={handleMenuClick}
				className="member-navigation__menu"
			/>
		</Sider>
	);
};

export default CashDisbursementStaffNavigation;
